export const DropStatus = {
    NEW: 10,
    DISPATCHED: 20,
    BUSY: 30,
    DONE: 40,
    SKIPPED: 50,
    CANCELLED: 60,
    INTERRUPTED: 70
};